<style src="./Pagination.scss" lang="scss"></style>

<template lang="pug">
  .pagination
    ul.pagination__list
      li.pagination__item.is-prev(
        :class='{ "is-disabled": !hasPrev() }'
      )
        router-link.pagination__link(
          :to='{ path: $route.path, query: { ...$route.query, page: prevPage }}'
        )
          .pagination__arrow
            Icon(
              name='arrow'
            )
          span.pagination__label {{ $l10n("BACKWARD") }}
    
      li.pagination__item(
        v-if='hasFirst()'
      )
        router-link.pagination__link(
          :to='{ path: $route.path, query: { ...$route.query, page: 1 }}'
        ) 1

      li.pagination__item(
        v-if='hasFirst() && !nearFirst()'
      ) ...

      li.pagination__item(
        v-for='page in pages'
        :class='{ "is-current": current == page }'
      )
        router-link.pagination__link(
          :to='{ path: $route.path, query: { ...$route.query, page }}'
        ) {{ page }}

      li.pagination__item(
        v-if='hasLast() && !nearLast()'
      ) ...

      li.pagination__item(
        v-if='hasLast()'
      )
        router-link.pagination__link(
          :to='{ path: $route.path, query: { ...$route.query, page: totalPages }}'
        ) {{ totalPages }}

      li.pagination__item.is-next(
        :class='{ "is-disabled": !hasNext() }'
      )
        router-link.pagination__link(
          :to='{ path: $route.path, query: { ...$route.query, page: nextPage }}'
        )
          span.pagination__label {{ $l10n("FORWARD") }}
          .pagination__arrow
            Icon(
              name='arrow'
            )
</template>

<script>
import Icon from "@/components/Icon/Icon";
import { PAGINATION_PER_PAGE, PAGINATION_PAGE_RANGE } from "@/constants";

export default {
  props: {
    current: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: PAGINATION_PER_PAGE
    },
    pageRange: {
      type: Number,
      default: PAGINATION_PAGE_RANGE
    }
  },
  components: { Icon },
  computed: {
    pages() {
      const pages = [];

      for (let i = this.rangeStart; i <= this.rangeEnd; i++) {
        pages.push(i);
      }

      return pages;
    },
    rangeStart() {
      const start = this.current - this.pageRange;

      return start > 0 ? start : 1;
    },
    rangeEnd() {
      const end = this.current + this.pageRange;

      return end < this.totalPages ? end : this.totalPages;
    },
    totalPages() {
      return Math.ceil(this.total / this.perPage);
    },
    nextPage() {
      return this.current + 1;
    },
    prevPage() {
      return this.current - 1;
    }
  },
  methods: {
    hasFirst() {
      return this.rangeStart !== 1;
    },
    hasLast() {
      return this.rangeEnd < this.totalPages;
    },
    hasPrev() {
      return this.current > 1;
    },
    hasNext() {
      return this.current < this.totalPages;
    },
    nearFirst() {
      return this.current - this.pageRange <= 2;
    },
    nearLast() {
      return this.current + this.pageRange >= this.totalPages - 1;
    }
  }
};
</script>
